import { render } from "./DynamicContent.vue?vue&type=template&id=a6ea789c"
import script from "./DynamicContent.vue?vue&type=script&lang=js"
export * from "./DynamicContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__